// Map a skill name (as defined in mock.js) to a brand icon component.
// Uses react-icons/si (Simple Icons) for authentic brand logos,
// falls back to lucide-react icons for non-brand concepts (REST APIs, CI/CD, etc.)
import {
  SiReact, SiJavascript, SiHtml5, SiCss, SiMui, SiBootstrap,
  SiNodedotjs, SiExpress, SiGraphql, SiPostgresql, SiMysql,
  SiDocker, SiKubernetes, SiHelm, SiTerraform, SiGit,
  SiTypescript, SiPython, SiPhp, SiCplusplus, SiOpenjdk,
  SiGithub, SiCypress, SiPostman,
  SiLangchain, SiAnthropic, SiGithubcopilot,
} from "react-icons/si";
import { BsOpenai } from "react-icons/bs";
import { Cloud, Infinity as InfinityIcon, Network, FlaskConical, Code2, MousePointerClick } from "lucide-react";

// Wrap lucide icons so they receive the same {className} prop pattern as react-icons
const wrap = (Icon) => (props) => <Icon {...props} />;

const map = {
  // Frontend
  "ReactJS": SiReact,
  "JavaScript": SiJavascript,
  "HTML": SiHtml5,
  "CSS": SiCss,
  "Material UI": SiMui,
  "JavaFX": SiOpenjdk,
  "Bootstrap": SiBootstrap,

  // Backend
  "NodeJS": SiNodedotjs,
  "ExpressJS": SiExpress,
  "GraphQL": SiGraphql,
  "REST APIs": wrap(Network),
  "PostgreSQL": SiPostgresql,
  "MySQL": SiMysql,

  // DevOps & Cloud
  "Docker": SiDocker,
  "Kubernetes": SiKubernetes,
  "Helm": SiHelm,
  "Terraform": SiTerraform,
  "Azure": wrap(Cloud),
  "CI/CD": wrap(InfinityIcon),
  "Git": SiGit,

  // Languages
  "TypeScript": SiTypescript,
  "Python": SiPython,
  "Java": SiOpenjdk,
  "PHP": SiPhp,
  "C/C++": SiCplusplus,

  // Tools
  "GitHub": SiGithub,
  "Cypress": SiCypress,
  "JUnit": wrap(FlaskConical),
  "VS Code": wrap(Code2),
  "Postman": SiPostman,

  // AI Tools
  "GitHub Copilot": SiGithubcopilot,
  "OpenAI APIs": BsOpenai,
  "Claude": SiAnthropic,
  "Cursor": wrap(MousePointerClick),
  "LangChain": SiLangchain,
};

export const getSkillIcon = (name) => map[name] || wrap(Code2);
